/* eslint-disable */

import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { readContract } from "@wagmi/core"

import { equalensMultiBalanceAbi } from "@/domains/abis"

type EqualensMultiBalanceProps = {
  config: Config
  account: Address
  equalensMultiBalance: Address
  addresses: Array<Address>
}

export const equalensMultiBalance = async ({
  config,
  equalensMultiBalance,
  account,
  addresses,
}: EqualensMultiBalanceProps) => {
  if (!account || !equalensMultiBalance || !config || !addresses) {
    return undefined
  }

  const results = await readContract(config, {
    abi: equalensMultiBalanceAbi,
    address: equalensMultiBalance,
    functionName: "balancesOf",
    args: [addresses, [account]],
  })

  return results
}
